import { serializeTokenMatch } from './tokens';
import { TokenConfig } from '../types';
import { getTokenAttrs, TOKEN_KEY_ATTR } from './token-element';

const BLOCK_TAGS = new Set(['DIV', 'P']);

const isTokenElement = (node: Node): node is HTMLElement => {
  return node instanceof HTMLElement && node.hasAttribute(TOKEN_KEY_ATTR);
};

const isBlockElement = (node: Node): node is HTMLElement =>
  node instanceof HTMLElement && BLOCK_TAGS.has(node.tagName);

const isFillerLineBreak = (node: Node): boolean =>
  node instanceof HTMLBRElement &&
  node.nextSibling === null &&
  node.parentElement !== null &&
  isBlockElement(node.parentElement);

const processNode = (node: Node, config: TokenConfig): string => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? '';

  if (isTokenElement(node)) {
    const { key, match } = getTokenAttrs(node);
    const definition = config[key];
    return definition ? serializeTokenMatch(definition, match) : match;
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    return serializeRoot(node as HTMLElement, config);
  }
  return '';
};

export const serializeRoot = (
  root: HTMLElement,
  config: TokenConfig,
): string => {
  const nodes = Array.from(root.childNodes);
  const serialized = nodes.reduce((serialized, child, index) => {
    if (isFillerLineBreak(child)) return serialized;
    if (child instanceof HTMLBRElement) return `${serialized}\n`;
    if (isBlockElement(child)) {
      const lineBreak = index > 0 ? '\n' : '';
      return serialized + lineBreak + serializeRoot(child, config);
    }
    return serialized + processNode(child, config);
  }, '');
  return serialized;
};
